import { forwardRef } from "react";

import { InputBase, makeStyles, createStyles, Theme, InputBaseProps } from "@material-ui/core";

import { InputWrapper, InputWrapperProps } from "~components/InputWrapper";

type InputProps = {} & InputWrapperProps & InputBaseProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      padding: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,

      fontSize: 16,
      height: "auto",
      lineHeight: "24px",
      color: theme.palette.dark.main,

      backgroundColor: "white",
      borderRadius: 4,
      boxShadow: "0 1px 1px 0 rgba(51, 91, 130, 0.12), 0 0 1px 0 rgba(10, 31, 68, 0.1)",

      transition: "box-shadow ease-in-out .18s",

      "&:focus": {
        backgroundColor: "white",
        borderRadius: 4,
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}, 0 4px 8px 0 rgba(26, 99, 171, 0.12), 0 0 1px 0 rgba(26, 99, 171, 0.1)`,
      },

      "&:disabled": {
        opacity: 0.35,
      },
    },
    adornEnd: {
      "& svg": {
        position: "absolute",
        right: "8px",
      },
    },
  }),
);

export const Input = forwardRef(({ label, error, id, ...rest }: InputProps, ref) => {
  const customId = `input-${id ?? label}`;
  const classes = useStyles();

  return (
    <InputWrapper label={label} error={error} id={customId} input>
      <InputBase
        {...rest}
        classes={{ adornedEnd: classes.adornEnd, input: classes.input }}
        id={customId}
        inputRef={ref}
      />
    </InputWrapper>
  );
});
